import React from "react";
import people from "../assets/imgTwo/grp.svg";
import bg from "../assets/imgTwo/Group-pattern.svg";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const WalletScrollCards = () => {
  return (
    <div className="py-20 bg-gray-100 pb-[20em]">
      <h2 className="text-3xl font-bold text-center mb-12">
        What StartUps and Fintechs Can Achieve <br />
        <span className="text-black">with Uniswitch</span>
      </h2>

      <div className="relative max-w-[70em] mx-auto h-[2000px]">
        <div className="sticky top-20 z-10">
          <div
            className="bg-[#001100] shadow-lg rounded-xl p-6 h-[35em] transition-transform duration-500"
            style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <h3 className="text-5xl font-bold text-white mt-20">API-Driven Payment Solutions</h3>
            <p className="text-2xl text-white mt-10">Integrate secure and flexible payment processing with Uniswitch to streamline transactions, enhance user experience, and ensure scalability with a variety of payment methods and robust security features.</p>
          </div>
        </div>

        <div className="sticky top-32 z-20">
          <div
            className="bg-[#07775D] shadow-lg rounded-xl p-6 h-[35em] transition-transform duration-500"
            style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <h3 className="text-5xl font-bold text-white mt-20">Wallet and Virtual Account Management</h3>
            <p className="text-2xl text-white mt-10">Offer digital wallets and unique virtual accounts to users, providing a seamless and secure way to manage their finances and make transactions.</p>
          </div>
        </div>

        <div className="sticky top-44 z-30">
          <div
            className="bg-[#83BBAE] shadow-lg rounded-xl p-6 h-[35em] transition-transform duration-500"
            style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <h3 className="text-5xl font-bold mt-20">Embedded Finance & White-Label Solutions</h3>
            <p className="text-2xl mt-10">Customize financial services under your brand to offer tailored solutions that align with your business identity and meet your customers' unique needs.</p>
          </div>
        </div>

        <div className="sticky top-56 z-40">
          <div
            className="bg-[#CDE4DF] shadow-lg rounded-xl p-6 h-[35em] transition-transform duration-500"
            style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <h3 className="text-5xl font-bold mt-20">Payout & Settlement Solutions</h3>
            <p className="text-2xl mt-10">Automate merchant settlements and disbursements to streamline payments, reduce manual processes, and ensure timely and accurate transactions.</p>
          </div>
        </div>
      </div>
    </div>
  );
};


const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
           Fueling Startups and<br></br> Fintechs with Scalable<br></br> Payment Innovation   </h2>
          <p className="text-gray-800 text-lg">
            Fintech startups need a reliable and scalable payment infrastructure to launch, grow, and innovate seamlessly. With Uniswitch, they can streamline transactions, enhance security, and expand effortlessly.
          </p>


        </div>
        <div className="w-full md:w-[35em] p-2 flex md:justify-end">
          <img src={people} alt="sarepay" className="rounded-lg" />

        </div>
      </div>
    </section>
  );
};



export const StartUps = () => (
  <div className="font-san mx-auto bg-[#FFFFFF] pt-6">
    <Navbar />
    <HeroSection />
    <WalletScrollCards />
    <Footer />
  </div>
);

export default StartUps;
